import React, { useEffect,useMemo,useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './Countdown.css';
import url from 'url';
import { FetchResultVisible } from '../actions/EpikBoxes';

const Countdown = () => {
  const dispatch = useDispatch();
  const initiateAlarmTimer = useSelector(state => state.UIState.epikBoxes.initiateAlarmTimer);

  const urlObj = url.parse(document.location.href, true);
  const innerBox = urlObj.path.includes('company');

  const [time, setTime] = useState({ h: 0, m: 0, s: 0 });
  const [timeLeft, setTimeLeft] = useState(() => {
    return parseInt(localStorage.getItem('timeLeft')) || initiateAlarmTimer || 0;
  });
  const [start, setStart] = useState(false);
  const intervalRef = useRef();

  const fetchResult = async (status) => {
    await dispatch(FetchResultVisible(status));
  };

  useEffect(() => {
    clearInterval(intervalRef.current);
    if (initiateAlarmTimer > 0) {
      setStart(true);
      setTimeLeft(initiateAlarmTimer);
      localStorage.setItem('timeLeft', initiateAlarmTimer);  // ✅ Save to localStorage
      fetchResult(true);
    } else {
      setTimeLeft(0);
      localStorage.removeItem('timeLeft');  // ✅ Clear when timer is zero
      fetchResult(false);
    }
  }, [initiateAlarmTimer]);

  useEffect(() => {
    if (timeLeft > 0) {
      intervalRef.current = setInterval(() => {
        setTimeLeft(prev => {
          const newTime = prev - 1;
          localStorage.setItem('timeLeft', newTime);
          return newTime;
        });
      }, 1000);
      setStart(true);
    }
    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (!innerBox) {
      setTimeLeft(0);
      localStorage.removeItem('timeLeft');
    }
    if (timeLeft <= 0) {
      clearInterval(intervalRef.current);
      fetchResult(false);
      localStorage.removeItem('timeLeft'); // ✅ Remove timer from storage
    }
    if (start) {
      intervalRef.current = setInterval(() => {
        setTimeLeft(prev => {
          const newTime = prev - 1;
          localStorage.setItem('timeLeft', newTime);
          return newTime;
        });
      }, 1000);
      setStart(false);
    }
    // convert timeLedt into minutes, seconds
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    setTime({ h: 0, m: minutes, s: seconds });
  }, [timeLeft]);

  return (
    <div className="text-center pl-1">
      {innerBox && timeLeft > 0 && initiateAlarmTimer > 0 && (
        <p className="time-text">
          Alarm Test Mode Initiated:
          {` ${time.m} Min ${time.s} Sec`}
        </p>
      )}
    </div>
  );
};

export default Countdown;
